interface Props {
  className?: string
}

const ThunderIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.597656 11.3399L11.4179 0.526077H24.5905L13.7702 11.3399H25.4373L13.7702 23H2.10309L13.7702 11.3399H0.597656Z"
        fill="url(#paint0_linear_3205_66645)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3205_66645"
          x1="11.2802"
          y1="-0.445609"
          x2="18.9107"
          y2="21.6826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0368FE" />
          <stop offset="1" stopColor="#00FFF0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ThunderIcon
